import { useState, useEffect, useContext } from "react";
import { useTheme, Box, Button, TextField, Typography } from "@mui/material";
import ReactPhoneInput from 'react-phone-input-material-ui';
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Select, MenuItem } from "@mui/material";
import Header from "../../components/Header";
import useToast from "../../components/useToast";
import { tokens } from "../../theme";
import axios from 'axios';
import { API_BASE_URL } from "../../config";
import { useTranslation } from 'react-i18next';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import '../../i18n';  
import { useNavigate } from "react-router-dom";



const Token_Registration = ({}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const { t, i18n } = useTranslation();
  const { success, error: showError } = useToast();
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const navigate = useNavigate();

  

  
  const handleFormSubmit = async (values) => {
    try {
      // Send the updated form values to the server for database update
      await axios.post(`${API_BASE_URL}/api/token_registration`, values, {
    headers: {
        'Content-Type': 'application/json',
        }
    });
      navigate('/login');
      success(t("registration.success"));
    } catch (error) {
      // console.error('Error updating registration details:', error);
      showError(t("registration.no_success"));
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowPassword2 = () => {
    setShowPassword2(!showPassword2);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };


  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100%"
      sx={{
        position: "relative",
        backgroundImage: `url(/assets/background.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
    <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          zIndex: 1,
        }}
      />
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        sx={{ zIndex: 2 }}
      >
    <Box 
      width={isNonMobile ? "auto" : "100%"} // Keep "auto" for non-mobile, full width for mobile
      p={isNonMobile ? 2 : 1} // Adjust padding for mobile if necessary
      sx={{
        ...(isNonMobile
          ? {
              bgcolor: "rgba(0, 0, 0, 0.5)",
              borderRadius: "8px",
              border: "1px solid #a3a3a3",
            }
          : {
            }),
        maxWidth: isNonMobile ? "600px" : "none", // Restrict width only for non-mobile
        maxHeight: isNonMobile ? "none" : "calc(100vh - 50px)", // Restrict height only for mobile
        overflowY: isNonMobile ? "visible" : "auto", // Enable scrolling only on mobile
      }}
    >
      <Button
        variant="contained"
        href="/login"
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
        }}
      >
        {t("button.back")}
      </Button>
      <Box mb="30px">
          <Typography
            variant="h2"
            color="white"
            fontWeight="bold"
            sx={{ m: "0 0 5px 0" }}
          >
            {t('registration.title')}
          </Typography>
        </Box>
      <Formik
        onSubmit={handleFormSubmit}
        enableReinitialize={true}
        initialValues={{}}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="10px"
              gridTemplateColumns={isNonMobile ? "repeat(2, 1fr)" : "repeat(2, 1fr)"}
              sx={{
                width: "100%",
                maxWidth: "600px", // Limit width on larger screens
                padding: isNonMobile ? "20px" : "10px",
                boxShadow: isNonMobile ? "none" : "none",
                columnGap: "10px",
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label={t('registration.token')}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.token}
                name="token"
                error={!!touched.token && !!errors.token}
                helperText={touched.token && errors.token}
                sx={{
                  gridColumn: "span 2",
                }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label={t('registration.first_name')}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.first_name}
                name="first_name"
                error={!!touched.first_name && !!errors.first_name}
                helperText={touched.first_name && errors.first_name}
                sx={{
                  gridColumn: isNonMobile ? "span 1" : "span 1",
                }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label={t('registration.last_name')}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.last_name}
                name="last_name"
                error={!!touched.last_name && !!errors.last_name}
                helperText={touched.last_name && errors.last_name}
                sx={{
                  gridColumn: isNonMobile ? "span 1" : "span 1",
                }}
              />
              {/* <Typography
                variant=""
                sx={{
                  gridColumn: "span 2",
                  display: "grid",
                  alignItems: "center",
                  height: "100%",
                }}
                >
              </Typography> */}

              <TextField
                fullWidth
                variant="filled"
                type="text"
                label={t('registration.email')}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.email}
                name="email"
                error={!!touched.email && !!errors.email}
                helperText={touched.email && errors.email}
                sx={{
                  gridColumn: "span 2",
                }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label={t('registration.phone_number')}
                onBlur={handleBlur}
                onChange={handleChange}
                defaultCountry={'ch'}
                value={values.phone_number}
                name="phone_number"
                error={!!touched.phone_number && !!errors.phone_number}
                helperText={touched.phone_number && errors.phone_number}
                sx={{
                  gridColumn: "span 2",
                }}
              />
              {/* <Typography
                variant=""
                sx={{
                  gridColumn: "span 2",
                  display: "grid",
                  alignItems: "center",
                  height: "100%",
                }}
                >
              </Typography> */}

              <TextField
                fullWidth
                variant="filled"
                type={showPassword ? 'text' : 'password'}
                label={t("registration.password")}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.password}
                name="password"
                error={!!touched.password && !!errors.password}
                helperText={touched.password && errors.password}
                sx={{
                  gridColumn: isNonMobile ? "span 1" : "span 1",
                }}
                InputProps={
                  isNonMobile
                    ? {
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            sx={{ color: 'white' }}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }
                  : undefined // No `InputProps` for mobile
                }
              />
              <TextField
                fullWidth
                variant="filled"
                type={showPassword2 ? 'text' : 'password'}
                label={t("registration.password2")}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.password2}
                name="password2"
                error={!!touched.password2 && !!errors.password2}
                helperText={touched.password2 && errors.password2}
                sx={{
                  gridColumn: isNonMobile ? "span 1" : "span 1",
                }}
                InputProps={
                  isNonMobile
                    ? {
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            sx={{ color: 'white' }}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }
                  : undefined // No `InputProps` for mobile
                }
              />
              {values.password !== values.password2 && touched.password2}
              {/* <Typography
                variant=""
                sx={{
                  gridColumn: "span 2",
                  display: "grid",
                  alignItems: "center",
                  height: "100%",
                }}
                >
              </Typography> */}

            </Box>
            <></>
            
            <Box display="left" justifyContent="end" mt="20px">
            <Button type="submit" color="primary" variant="contained"
              sx={{
                backgroundColor: "#3da58a", // Set button color to green
                '&:hover': {
                  backgroundColor: "#1BB598", // Adjust hover color if needed
                },
              }}>
                {t("button.submit")}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
      
    </Box>
    </Box>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  token: yup
    .string()
    .matches(/^\d{6}$/, "Token enthält 6 Ziffern")
    .required("erforderlich"),
  email: yup.string().email("ungültige Email").required("erforderlich"),
  first_name: yup.string().required("erforderlich"),
  last_name: yup.string().required("erforderlich"),
  password: yup.string().required("erforderlich"),
  password2: yup
  .string()
  .oneOf([yup.ref("password"), null], "Passwort stimmt nicht überein")
  .required("erforderlich"),
  phone_number: yup.string()
    .matches(/^004\d+$/, "Telefonummer muss mit 004 starten und besteht nur aus Zahlen")
    .nullable() // Erlaubt null als Wert
    .notRequired(),
});


export default Token_Registration;
